module.exports = __webpack_public_path__ + "static/media/product_logo.99106b38.png";